module.exports = __webpack_public_path__ + "static/media/img-new-01@2x.94b9acc3.png";